import React from 'react';
import { AppBar,IconButton, Toolbar ,Badge, useMediaQuery, Menu, MenuItem, useTheme,Typography,ListItem, ListItemIcon} from '@material-ui/core';
import { NavLink } from './styles';
// import DrawerComponent from '../Drawer/DrawerComponent';
import { ShoppingCart } from '@material-ui/icons';
import { Link, useLocation } from 'react-router-dom';
import MenuIcon from "@material-ui/icons/Menu";
import logo from '../../assets/logo.png';
import useStyles from './styles';


const Navbar = ({categories, totalItems }) => {
  const classes = useStyles();
  const location = useLocation();
  const [anchor, setAnchor] = React.useState(null);
  const open = Boolean(anchor);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const handleMenu = (event) => {
    setAnchor(event.currentTarget);
  };
  // const categorias = categories.map((category) =>  <p className={classes.a} href={`/#${category.name}`} >{category.name}</p>);

  return (
    <>
      <AppBar position="fixed" className={classes.appBar} color="inherit">
        <Toolbar>
          <Typography component={Link} to="/" variant="h6" className={classes.title} color="inherit">
            <img src={logo} alt="oaxaqueña" height="25px" className={classes.image}/>
          </Typography>
          <div className={classes.grow} />
            {isMobile ? (
                <>
                  <IconButton color="textPrimary" className={classes.menuButton} edge="start" aria-label="menu" onClick={handleMenu}>
                    <MenuIcon />
                  </IconButton>
                  <Menu id="menu-appbar" anchorEl={anchor} anchorOrigin={{vertical: "top", horizontal: "right"}}KeepMounted transformOrigin={{ vertical: "top", horizontal: "right"}} open={open}>
                    {categories.map(category => {
                      return (
                        <MenuItem onClick={() => setAnchor(null)}>
                          <ListItem>
                            <li>
                              <NavLink
                                font-size="1rem"
                                href={`/#${category.name}`}
                                className={classes.a}
                              >
                                {category.name}
                              </NavLink>
                            </li>
                          </ListItem>
                        </MenuItem>
                      );
                    })}
                  </Menu>
                </>
              ) : (
          <div className={classes.navlinks}>           
            {categories.map(category => <NavLink href={`/#${category.name}`} className={classes.link}>{category.name}</NavLink>)}
          </div>
        )}
        
          {location.pathname === '/' && (
          <div className={classes.button}>
            <IconButton component={Link} to="/cart" aria-label="Show cart items" color="inherit">
              <Badge badgeContent={totalItems} color="secondary">
                <ShoppingCart />
              </Badge>
            </IconButton>
          </div>) }
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Navbar;
